webpackJsonp([4],{

/***/ 503:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['data', 'image']
});

/***/ }),

/***/ 514:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(451)(true);
// imports


// module
exports.push([module.i, ".close-btn[data-v-077c9f05]{right:14px;top:14px}.content-wrap[data-v-077c9f05]{border:1px solid rgba(0,0,0,.1)}.postfix-wrap[data-v-077c9f05]{border-top:1px solid rgba(0,0,0,.1)}.prefix-wrap[data-v-077c9f05]{border-bottom:1px solid rgba(0,0,0,.1)}.equalseparator[data-v-077c9f05],.lineseparator[data-v-077c9f05]{position:relative;border-bottom:2px dashed rgba(0,0,0,.4);width:100%;background:none}.equalseparator[data-v-077c9f05]{padding-top:5px}.equalseparator[data-v-077c9f05]:after{content:\"\";display:block;height:2px;border-bottom:2px dashed rgba(0,0,0,.4);position:absolute;bottom:3px;width:100%}.img-wrap[data-v-077c9f05]{position:relative;overflow:hidden;width:100%;height:auto;max-height:90%;display:flex}.img-wrap img[data-v-077c9f05]{align-self:center;height:auto;width:auto}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/modals/PreviewPrePost.vue"],"names":[],"mappings":"AACA,4BACE,WAAY,AACZ,QAAU,CACX,AACD,+BACE,+BAAqC,CACtC,AACD,+BACE,mCAAyC,CAC1C,AACD,8BACE,sCAA4C,CAC7C,AACD,iEACE,kBAAmB,AACnB,wCAA6C,AAC7C,WAAY,AACZ,eAAiB,CAClB,AACD,iCACE,eAAiB,CAClB,AACD,uCACI,WAAY,AACZ,cAAe,AACf,WAAY,AACZ,wCAA6C,AAC7C,kBAAmB,AACnB,WAAY,AACZ,UAAY,CACf,AACD,2BACE,kBAAmB,AACnB,gBAAiB,AACjB,WAAY,AACZ,YAAa,AACb,eAAgB,AAChB,YAAc,CACf,AACD,+BACI,kBAAmB,AACnB,YAAa,AACb,UAAY,CACf","file":"PreviewPrePost.vue","sourcesContent":["\n.close-btn[data-v-077c9f05] {\n  right: 14px;\n  top: 14px;\n}\n.content-wrap[data-v-077c9f05] {\n  border: 1px solid rgba(0, 0, 0, 0.1);\n}\n.postfix-wrap[data-v-077c9f05] {\n  border-top: 1px solid rgba(0, 0, 0, 0.1);\n}\n.prefix-wrap[data-v-077c9f05] {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n}\n.lineseparator[data-v-077c9f05], .equalseparator[data-v-077c9f05] {\n  position: relative;\n  border-bottom: 2px dashed rgba(0, 0, 0, 0.4);\n  width: 100%;\n  background: none;\n}\n.equalseparator[data-v-077c9f05] {\n  padding-top: 5px;\n}\n.equalseparator[data-v-077c9f05]::after {\n    content: '';\n    display: block;\n    height: 2px;\n    border-bottom: 2px dashed rgba(0, 0, 0, 0.4);\n    position: absolute;\n    bottom: 3px;\n    width: 100%;\n}\n.img-wrap[data-v-077c9f05] {\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n  height: auto;\n  max-height: 90%;\n  display: flex;\n}\n.img-wrap img[data-v-077c9f05] {\n    align-self: center;\n    height: auto;\n    width: auto;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 540:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(514);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(452)("699aafa7", content, true, {});

/***/ }),

/***/ 566:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "pa-4"
  }, [(_vm.data) ? _c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "justify-space-between": ""
    }
  }, [_c('h2', {
    staticClass: "mb-4"
  }, [_vm._v("Preview")]), _vm._v(" "), _c('v-btn', {
    staticClass: "close-btn",
    attrs: {
      "fab": "",
      "small": "",
      "flat": "",
      "absolute": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "content-wrap"
  }, [(_vm.data.prefixLines.length > 0) ? _c('div', {
    staticClass: "prefix-wrap pa-3"
  }, [_vm._l((_vm.data.prefixLines), function(prefix, i) {
    return [(prefix.content === 'emptyline') ? _c('p', {
      key: i,
      staticClass: "pb-3"
    }) : (prefix.content === 'lineseparator') ? _c('hr', {
      key: i,
      staticClass: "my-3 lineseparator"
    }) : (prefix.content === 'equalseparator') ? _c('hr', {
      key: i,
      staticClass: "my-3 equalseparator"
    }) : (prefix.content === 'image') ? _c('div', {
      key: i,
      staticClass: "img-wrap"
    }, [_c('img', {
      attrs: {
        "src": prefix.data,
        "alt": ""
      }
    })]) : _c('p', {
      key: i,
      staticClass: "mb-0",
      style: ({
        fontSize: ((prefix.fontHeight) + "px"),
        fontWeight: prefix.fontStyle === 'bold' ? 'bold' : null,
        fontStyle: prefix.fontStyle === 'italic' ? 'italic' : null,
      })
    }, [_vm._v("\n            " + _vm._s(prefix.content === 'opencashdrawer' ? 'open cashdrawer' : prefix.content) + "\n          ")])]
  })], 2) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "content mb-0 pa-3"
  }, [_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit. Harum enim, perspiciatis,\n        animi magnam vel placeat consequatur nisi architecto aut iure repudiandae debitis itaque fugit.\n        Omnis facilis illo laudantium consequuntur perspiciatis?")]), _vm._v(" "), (_vm.data.postfixLines.length > 0) ? _c('div', {
    staticClass: "postfix-wrap pa-3"
  }, [_vm._l((_vm.data.postfixLines), function(postfix, index) {
    return [(postfix.content === 'emptyline') ? _c('p', {
      key: index,
      staticClass: "pb-3"
    }) : (postfix.content === 'lineseparator') ? _c('hr', {
      key: index,
      staticClass: "my-3 lineseparator"
    }) : (postfix.content === 'equalseparator') ? _c('hr', {
      key: index,
      staticClass: "my-3 equalseparator"
    }) : (postfix.content === 'image') ? _c('div', {
      key: index,
      staticClass: "img-wrap"
    }, [_c('img', {
      attrs: {
        "src": postfix.data,
        "alt": ""
      }
    })]) : _c('p', {
      key: index,
      staticClass: "mb-0",
      style: ({
        fontSize: ((postfix.fontHeight) + "px"),
        fontWeight: postfix.fontStyle === 'bold' ? 'bold' : null,
        fontStyle: postfix.fontStyle === 'italic' ? 'italic' : null,
      })
    }, [_vm._v("\n            " + _vm._s(postfix.content === 'opencashdrawer' ? 'open cashdrawer' : postfix.content) + "\n          ")])]
  })], 2) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.image) ? _c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "justify-space-between": ""
    }
  }, [_c('h2', {
    staticClass: "mb-4"
  }, [_vm._v("Preview")]), _vm._v(" "), _c('v-btn', {
    staticClass: "close-btn",
    attrs: {
      "fab": "",
      "small": "",
      "flat": "",
      "absolute": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "content-wrap"
  }, [_c('div', {
    staticClass: "prefix-wrap pa-3"
  }, [_c('div', {
    staticClass: "img-wrap fluid"
  }, [_c('img', {
    attrs: {
      "src": _vm.image.base64Image,
      "alt": ""
    }
  })])])])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(540)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(503),
  /* template */
  __webpack_require__(566),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-077c9f05",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/4.8cd1af55f5fbb37236f5.js